import React from 'react'
import './App.css'
import Navbar from './Components/Navbar/navbar'
import Home from './Components/Home/Home'
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import Destin from './Components/Destination/Destin'
import Crew from './Components/Crew/Crew'
import Tech from './Components/Technology/Tech'
import { useState } from 'react'
const App = (props) => {
  const [toggles, settoggles] = useState([])

const toogle = (data) => {
  settoggles(data)
}
  return (
    <>
 
      <BrowserRouter>
      {toggles? <div className='backbox'></div>:''}
    <div className='navapp'>
    <Navbar toogle={toogle}/>
    </div>
      
      <div className='app'>
     
      <div className='mainapp'>
   
     <Routes>
      <Route exact path='/' Component={Home}/>
      <Route exact path='/destination' Component={Destin}/>
      <Route exact path='/crew' Component={Crew}/>
      <Route exact path='/tech' Component={Tech}/>
     </Routes>
  
      
      </div>

    </div>
    </BrowserRouter>
    </>
  
  )
}

export default App